import Button from '../ui_components/button/button';
import GridTableBodyE from '../ui_components/gridTable/GridTableBody';
import GridTableCellE from '../ui_components/gridTable/GridTableCell';
import GridTableE from '../ui_components/gridTable/GridTable';
import GridTableRowE from '../ui_components/gridTable/GridTableRow';
import { ValidationPopupInput } from '../ui_components/validation/validationPopupInput';
import { Modal, ModalActions, ModalContent, ModalHeader } from '../ui_components/modal';
import PageDimmer from '../ui_components/dimmer/PageDimmer';
import { DispatchProp, connect } from 'react-redux';
import { DraperyModule, WorkOrderModule } from '../redux/modules/index';
import React, { ChangeEvent, PureComponent } from 'react';
import {
  CalculatorRadio,
  CalculatorRadioWrapper,
  TooltipPopup,
  TooltipText,
} from '../components/calculator/styles';
import styled, { css, theme } from '../theme';

import DraperyConfiguration3Panels from '../../src/assets/icons/configuration/panels-3.svg';
import DraperyConfiguration4Panels from '../../src/assets/icons/configuration/panels-4.svg';
import DraperyConfiguration5Panels from '../../src/assets/icons/configuration/panels-5.svg';
import DraperyConfigurationPair from '../../src/assets/icons/configuration/panels-pair.svg';
import DraperyConfigurationSingleCenterPanel from '../../src/assets/icons/configuration/panels_single.svg';
import DraperyConfigurationSingleLeftPanel from '../../src/assets/icons/configuration/panels-left.svg';
import DraperyConfigurationSingleRightPanel from '../../src/assets/icons/configuration/panels-right.svg';
import { RootState } from '../redux';
import SelectList from '../components/UI/select-list';
import { getWorkOrderRecommendations, saveWorkOrderOverrides } from '../api/work-order';

import { AnyAction } from 'redux';
import { searchWorkroomSetting } from '../api/workroom-setting';

const ModalHeaderRecommendationsOverrides = styled(ModalHeader)`
  color: #306f82 !important;
  border-bottom: none;
  padding-bottom: 0 !important;

  div {
    width: 100% !important;
    border-bottom: 10px solid #e6f1f4 !important;
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    padding-bottom: 0.5rem !important;
  }

  .modal-title {
    font-size: 26px !important;
  }
`;

const ModalSpanWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ModalSpan = styled.span`
  color: ${theme.colors.primary};
`;

const TwoCounterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 6% 5% 0;
`;

const TwoCounterTitleBox = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: 600;
`;

const TwoCounterLabelValueBox = styled.div`
  display: flex;
  flex-direction: row;
`;

const TwoCounterLabel = styled.div`
  display: flex;
  justify-content: flex-start;
  //margin-top: 10px;
`;

const TwoCounterValue = styled.span`
  color: ${theme.colors.primary};
  font-weight: bold;
  display: flex;
  justify-content: center;
  //margin: 10px 20px 0 0;
  padding: 0 5px;
  min-width: 25px;
`;

const PanelConfigurationWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const PanelConfigurationSubWrapper = styled.div`
  // margin-top: 20px;
  display: flex;
  flex-direction: column;
`;

const PanelConfigurationBox = styled.div`
  margin-top: 5px;
  border-radius: 0.5em;
  // width: 400px;
  // width: 350px;
  border: 2px solid rgb(150, 150, 150);

  > div:first-child {
    padding: 20px 20px 5px;
  }

  > div:last-child {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }
`;

interface ConfigurationValueProps {
  panelType?: string | undefined;
}

const PanelConfigurationValueWrapper = styled.div<ConfigurationValueProps>`
  width: 55px;
  min-width: 35px;
  max-width: 55px;
  color: ${theme.colors.grayRGBA};
  text-align: center;
  font-size: 12px;
  ${(props) =>
    props.panelType === 'left' &&
    css`
      // margin-right: 155px;
      margin-right: 85px;
    `}
  ${(props) =>
    props.panelType === 'right' &&
    css`
      // margin-left: 155px;
      margin-left: 85px;
    `}
    ${(props) =>
    props.panelType === 'pair' &&
    css`
      // margin: 0 40px;
      margin: 0 8px;
    `}
    ${(props) =>
    props.panelType === 'three-panels' &&
    css`
      // margin: 0 23px;
      margin: 0 12px;
    `}
    ${(props) =>
    props.panelType === 'four-panels' &&
    css`
      // margin: 0 12px;
      margin: 0 4px;
    `}
    ${(props) =>
    props.panelType === 'five-panels' &&
    css`
      // margin: 0 5px;
      margin: 0 4px;
    `}
`;

const PanelConfigurationValue = styled(SelectList)<ConfigurationValueProps>`
  border-radius: 0.5em;
  color: ${theme.colors.primary};
  width: 60px;
  min-width: 50px;
  max-width: 60px;
  margin-bottom: 5px;

  input {
    font-weight: bold;
  }
`;
PanelConfigurationValue.defaultProps = {
  noAddButton: true,
  noClearBox: true,
  noArrow: false,
  smallPadding: true,
  flexDirection: 'column',
};

export const Subtitle = styled.h5`
  color: #338daa;
  font-weight: bold;
  letter-spacing: 1.3px;
  margin: 0;
`;

const GridTableWrapper = styled.div`
  margin-top: 20px;
`;

const GridTable = styled(GridTableE)`
  border: 0;
`;

const GridTableRow = styled(GridTableRowE)`
  grid-template-columns: 1.7fr 1fr 1fr;
  grid-template-rows: auto;
  grid-template-areas: 'name1 name2 name3';
  grid-column-gap: 0;
  font-weight: 600 !important;
  color: #4a4a4a;
  text-align: left;
  background-color: #ecf6f9 !important;
  padding: 0;
  border-bottom: 1px solid ${theme.colors.grayRGBA};

  // &:hover {
  //     background-color: #c1dcec;
  // }
`;

const GridTableCell = styled(GridTableCellE)`
  border-left: 1px solid ${theme.colors.grayRGBA} !important;
  border-top: 1px solid ${theme.colors.grayRGBA} !important;
  color: ${theme.colors.grayRGBA} !important;
  padding: 5px 10px !important;
  justify-content: center;

  &:last-child {
    border-right: 1px solid ${theme.colors.grayRGBA} !important;
  }
`;

const FirstGridTableCell = styled(GridTableCellE)`
  background: white !important;
  padding: 20px 10px !important;
  border-left: 1px solid ${theme.colors.grayRGBA} !important;

  &:first-child {
    border-left: none !important;
  }
`;

const GridTitleBox = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const GridTableBody = styled(GridTableBodyE)`
  overflow: auto;
`;

const Row = styled(GridTableRowE)`
  grid-template-columns: 1.7fr 1fr 1fr !important;
  grid-template-rows: auto !important;
  grid-column-gap: 0 !important;
  padding: 0 !important;
  color: #000 !important;

  &:last-child {
    border: 0 !important;
  }

  &:hover {
    background-color: #f8f5f8 !important;
  }
`;

const BasicGridTableCell = styled(GridTableCellE)`
  text-align: left !important;
  display: flex !important;
  align-items: center !important;
  padding: 10px 10px !important;
  border: 1px solid ${theme.colors.grayRGBA} !important;
  border-right: none !important;
  border-top: none !important;
  font-size: 15px;

  &:last-child {
    border-right: 1px solid ${theme.colors.grayRGBA} !important;
  }
`;
const BasicSubGridTableCell = styled(BasicGridTableCell)`
  justify-content: center !important;
  color: ${theme.colors.primary};
`;

const ModalInput = styled(ValidationPopupInput)`
  padding: 16px 5px;
  height: 23px;
  width: 75px;
`;
const ValidateBox = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: center;
  color: darkred;
  background-color: #fff2f3;
  border: solid #f5c6cb 1px;
  border-radius: 0.5em;
`;

const CancelButton = styled(Button)`
  box-shadow: none !important;
  margin-right: auto !important;
`;

const PanelPreviousWidthBox = styled.div`
  text-align: center;
  margin-top: 10px;
`;

export interface RecommendationsOverridesModalOwnProps {
  active: boolean;
  draperyOrderId: number;
  isFunctional: boolean;
  panelType?: string | undefined;
  data: any;
  selectedPanels: number;
  onRequestClose(): void;
  handleConfirm(
    panelJson: DraperyModule.DraperyOrderDesignPanelJson,
    workRoomSettings: any[],
    widthConfiguration: Array<number | undefined>
  ): void;
  editMode: boolean;
  draperyOrderDesign: DraperyModule.DraperyOrderDesign;
  newDraperyOrderFabrics: any[];
  workOrderEditMode: boolean;
  resetDraperyOrderNewFabrics(): void;
  handleSaveAll(val?: string): Promise<boolean>;
  resetAfterUpdatingEmbellishments(): void;
  isCopy: boolean;
}

export interface RecommendationsOverridesModalProps extends RecommendationsOverridesModalOwnProps {
  accountId: number;
  editMode: boolean;
}

interface State {
  updating: boolean;
  isNext: boolean;
  /**
   * Panel width configuration. index is the panel number
   */
  widthConfiguration: Array<number | undefined>;
  /**
   * Total width recommendation from all panels
   */
  totalWidthRecommendation: number;
  /**
   * Yardage overrides
   */
  yardageRecommendations: Array<
    WorkOrderModule.WorkOrderFabricYardage & {
      overriden?: string;
      isChecked?: boolean;
      isCheckedOverride?: boolean;
    }
  >;
  otherFabricYardageRecommendations: Array<
    WorkOrderModule.WorkOrderFabricYardage & {
      overriden?: string;
      isChecked?: boolean;
      isCheckedOverride?: boolean;
    }
  >;

  copyYardageRecommendations: Array<
    WorkOrderModule.WorkOrderFabricYardage & {
      overriden?: string;
      isChecked?: boolean;
      isCheckedOverride?: boolean;
    }
  >;
  /**
   * recommendation
   */
  // workOrderRecommendations?: WorkOrderModule.WorkOrderRecommendations;
  /**
   * overrides
   */
  WorkOrderOverrides?: WorkOrderModule.WorkOrderOverrides;
  isValidate: boolean;
  validateMessage: string;
  isOverridesValidate: boolean;
  basePrice: string;
  workroomSettings: any[];
  updatingWorkOrder: boolean;
  widthsBordercolor: string[];
}

const PANEL_WIDTH_BORDER_COLOR = '#000';
const PANEL_WIDTH_MISSING_BORDER_COLOR = '#E11900';

const noop = () => {
  /* ignore */
};

export class RecommendationsOverridesModalComponent extends PureComponent<
  RecommendationsOverridesModalProps & DispatchProp,
  State
> {
  public constructor(props: RecommendationsOverridesModalProps & DispatchProp) {
    super(props);

    this.state = {
      updating: false,
      isNext: !props.isFunctional,
      totalWidthRecommendation: 0,
      widthConfiguration: [],
      yardageRecommendations: [],
      otherFabricYardageRecommendations: [],
      copyYardageRecommendations: [],
      isValidate: false,
      validateMessage: '',
      isOverridesValidate: false,
      basePrice: '',
      workroomSettings: [],
      updatingWorkOrder: false,
      // widthsBordercolor: '#E11900',
      widthsBordercolor: [],
    };
  }

  public async componentDidMount(): Promise<void> {
    const { accountId } = this.props;
    try {
      const res = await searchWorkroomSetting(accountId);
      if (res && !res.error && res && res.length > 0) {
        const workroomSettings = res;
        this.setState({ workroomSettings });
      } else {
        console.error('There is no information about the settings.');
      }
    } catch (error) {
      console.error('Error executing the dispatch function:', error);
    }

    // await this.getWorkOrderRecommendations();
  }

  private getNumberOfPanels(panelType: string): number {
    switch (panelType) {
      case 'center':
      case 'left':
      case 'right':
        return 1;
      case 'pair':
        return 2;
      case 'three-panels':
        return 3;
      case 'four-panels':
        return 4;
      case 'five-panels':
        return 5;
      default:
        return 1;
    }
  }

  private getPanelWidthBorderColors = (
    widthConfiguration: Array<number | undefined>,
    panelType: string = this.props.panelType || this.props.data.draperyOrderDesign.panelType
  ): string[] => {
    const numberOfPanels = this.getNumberOfPanels(panelType);

    return Array.from({ length: numberOfPanels }, (_, idx) =>
      widthConfiguration[idx] !== undefined
        ? PANEL_WIDTH_BORDER_COLOR
        : PANEL_WIDTH_MISSING_BORDER_COLOR
    );
  };

  private handleNumberOfPanels = (panelType: string) => {
    const savedPanelWidths = this.shouldRecalculatePanelWidths() ? [] : this.getSavedPanelWidths();

    this.setState((prevState) => ({
      ...prevState,
      widthsBordercolor: this.getPanelWidthBorderColors(savedPanelWidths, panelType),
    }));
  };

  private getSavedPanelWidths = (): Array<number | undefined> => {
    const panelJson = this.props.data.draperyOrderDesign.panelJson || {};

    return Object.keys(panelJson)
      .map((key) => panelJson[key])
      .filter((value) => value !== undefined);
  };

  private shouldRecalculatePanelWidths = (): boolean => {
    if (!this.props.workOrderEditMode) {
      return false;
    }

    const originalDesign =
      // this.props.data.stateObj?.draperyOrderDesign || 
      this.props.data.copyState?.draperyOrderDesign;

    if (!originalDesign) {
      return false;
    }

    return (
      originalDesign.panelType !== this.props.panelType ||
      (originalDesign.category === 0) !== this.props.isFunctional ||
      // originalDesign.pleatType !== this.props.draperyOrderDesign?.pleatType ||
      originalDesign.draperyFullness !==
        this.props.data.draperyOrderDesign?.draperyFullness
    );
  };

  private getInitialWidthConfiguration = (): Array<number | undefined> => {
    if (this.shouldRecalculatePanelWidths()) {
      return this.calculateInitialPanelWidths();
    }

    const savedPanelWidths = this.getSavedPanelWidths();

    return savedPanelWidths.length > 0 ? savedPanelWidths : this.calculateInitialPanelWidths();
  };

  // Prefill functional panel widths
  private handlePrefillWidths = () => {
    const widthConfiguration = this.getInitialWidthConfiguration();

    this.setState((prev) => {
      return {
        ...prev,
        widthConfiguration,
        widthsBordercolor: this.getPanelWidthBorderColors(widthConfiguration),
      };
    });
  };

  public async componentDidUpdate(
    prevProps: RecommendationsOverridesModalProps,
    prevState: any
  ): Promise<void> {
    const panelRecommendationInputChanged =
      prevProps.panelType !== this.props.panelType ||
      prevProps.isFunctional !== this.props.isFunctional ||
      // prevProps.draperyOrderDesign?.pleatType !== this.props.draperyOrderDesign?.pleatType ||
      prevProps.data.draperyOrderDesign?.draperyFullness !==
        this.props.data.draperyOrderDesign?.draperyFullness;

    if (prevProps.isFunctional !== this.props.isFunctional) {
      const widthConfiguration = this.calculateInitialPanelWidths(
        this.state.totalWidthRecommendation
      );

      this.setState({
        isNext: !this.props.isFunctional,
        widthConfiguration,
        widthsBordercolor: this.getPanelWidthBorderColors(widthConfiguration),
      });
    }

    if (panelRecommendationInputChanged) {
      const widthConfiguration = this.calculateInitialPanelWidths(
        this.state.totalWidthRecommendation
      );

      this.setState({
        widthConfiguration,
        widthsBordercolor: this.getPanelWidthBorderColors(widthConfiguration),
      });
    }

    if (this.props.draperyOrderId === 0 && prevProps.draperyOrderId !== 0) {
      const widthConfiguration = this.calculateInitialPanelWidths(
        this.state.totalWidthRecommendation
      );

      this.setState({
        widthConfiguration,
        widthsBordercolor: this.getPanelWidthBorderColors(widthConfiguration),
      });
    }

    if (
      this.props.workOrderEditMode &&
      prevProps.workOrderEditMode !== this.props.workOrderEditMode
    ) {
      // this.handlePrefillWidths();
    }

    if (this.state.updatingWorkOrder === true) {
      await this.save();
    }
  }
  componentWillReceiveProps(
    nextProps: Readonly<RecommendationsOverridesModalProps & DispatchProp<AnyAction>>,
    nextContext: any
  ): void {
    // if (nextProps.isCopy) {
    //     this.setState((state) => ({
    //         ...state,
    //         yardageRecommendations: this.state.yardageRecommendations.map(
    //             (item) => ({ ...item})
    //         ),
    //         copyYardageRecommendations:
    //             this.state.copyYardageRecommendations.map((item) => ({
    //                 ...item,
    //             })),
    //     }));
    // }
    if (nextProps.data.draperyOrderDesign.panelType) {
      this.handleNumberOfPanels(nextProps.data.draperyOrderDesign.panelType);
    }
  }
  public render(): JSX.Element {
    return this.renderModal();
  }

  private renderModal = () => {
    const { active } = this.props;
    return (
      <>
        <PageDimmer uiActive={active} />
        <Modal
          uiActive={active}
          uiOnRequestClose={noop}
          uiOnOpen={this.loadRecommendations}
          style={{
            height: `${this.state.isNext ? '' : '90vh'}`,
            maxHeight: `${this.state.isNext ? '90vh' : ''}`,
          }}
        >
          <ModalHeaderRecommendationsOverrides>
            <div>
              <span className="modal-title">
                {this.state.isNext ? 'Confirm Yardages' : 'Enter the Number of Widths'}
              </span>
            </div>
          </ModalHeaderRecommendationsOverrides>
          {this.state.isNext ? this.renderYardagesSelection() : this.renderWidthSelection()}
        </Modal>
      </>
    );
  };

  private renderWidthSelection = () => {
    const prefix =
      Object.keys(this.props.data.draperyOrderDesign.panelJson).length > 0 ? '(Was ' : '';
    const sufix = Object.keys(this.props.data.draperyOrderDesign.panelJson).length > 0 ? ')' : '';
    return (
      <>
        <ModalContent style={{ overflowY: 'auto' }}>
          <ModalSpanWrapper>
            {/*<ModalSpan>*/}
            {/*    Please choose number of widths for each panel.*/}
            {/*</ModalSpan>*/}
            <span style={{ display: 'flex', alignSelf: 'center' }}>
              {/*<TwoCounterLabel>QUIPA recommends using a total of:</TwoCounterLabel>*/}
              {/*<TwoCounterValue>*/}
              {/*    {this.state.totalWidthRecommendation}*/}
              {/*</TwoCounterValue>*/}
            </span>
            <span style={{ width: '107.5px' }}></span>
          </ModalSpanWrapper>

          <PanelConfigurationWrapper>
            <PanelConfigurationSubWrapper>
              <ModalSpan>
                {this.props.panelType === 'center' && 'SINGLE CENTER'}
                {this.props.panelType === 'left' && 'LEFT'}
                {this.props.panelType === 'right' && 'RIGHT'}
                {this.props.panelType === 'pair' && 'PAIR'}
                {this.props.panelType === 'three-panels' && '3 PANELS'}
                {this.props.panelType === 'four-panels' && '4 PANELS'}
                {this.props.panelType === 'five-panels' && '5 PANELS'}
              </ModalSpan>
              <PanelConfigurationBox
                style={{
                  width: ['center', 'left', 'right', 'pair'].includes(this.props.panelType || '')
                    ? '230px'
                    : '330px',
                }}
              >
                <div>{this.handlePanelConfigurationImage()}</div>
                <div>{this.generateConfigurationValue()}</div>
              </PanelConfigurationBox>
              {this.props.data.workOrder && this.props.data.workOrder.id !== 0 && (
                <PanelPreviousWidthBox>
                  {prefix +
                    Object.keys(this.props.data.draperyOrderDesign.panelJson)
                      .map((key) => this.props.data.draperyOrderDesign.panelJson[key])
                      .filter((value) => value !== undefined)
                      .map((value) => value + 'w')
                      .join(' - ') +
                    sufix}
                </PanelPreviousWidthBox>
              )}
            </PanelConfigurationSubWrapper>
          </PanelConfigurationWrapper>
          {this.state.isValidate && <ValidateBox>{this.state.validateMessage}</ValidateBox>}
          <TwoCounterWrapper>
            <TwoCounterTitleBox>TOTAL WIDTHS</TwoCounterTitleBox>
            <TwoCounterLabelValueBox>
              <TwoCounterLabel>Recommended:</TwoCounterLabel>
              <TwoCounterValue>{this.state.totalWidthRecommendation}</TwoCounterValue>
              <TwoCounterLabel>Added:</TwoCounterLabel>
              <TwoCounterValue>
                {this.state.widthConfiguration.length ? (
                  (this.total() || 0).toFixed(2) || <>&nbsp;</>
                ) : (
                  <>&nbsp;</>
                )}
              </TwoCounterValue>
            </TwoCounterLabelValueBox>
          </TwoCounterWrapper>
        </ModalContent>
        <ModalActions>
          <CancelButton
            className="cancel_btn"
            uiColor="secondary"
            uiDisabled={this.state.updating}
            onClick={this.handleClose}
          >
            Cancel
          </CancelButton>
          <Button form="cardform" uiColor="primary" onClick={this.handleNext}>
            Next
          </Button>
        </ModalActions>
      </>
    );
  };

  private renderYardagesSelection = () => {
    return (
      <>
        <ModalContent style={{ overflowY: 'auto' }}>
          <ModalSpan>
            Confirm or Override the yardages for the selected fabrics and embellishments.
          </ModalSpan>
          <GridTableWrapper>
            <GridTable>
              <GridTableRow>
                <FirstGridTableCell uiGridArea="name1" />
                <GridTableCell uiGridArea="name2">
                  <GridTitleBox className="text-sm md:text-md">
                    <Subtitle className="text-sm md:text-md">QUIPA Recommends</Subtitle>
                    (Yards)
                  </GridTitleBox>
                </GridTableCell>
                <GridTableCell uiGridArea="name3">
                  <GridTitleBox className="text-sm md:text-md">
                    <Subtitle className="text-sm md:text-md">Your Override</Subtitle>
                    (Yards)
                  </GridTitleBox>
                </GridTableCell>
              </GridTableRow>
              <GridTableBody>
                {this.state.yardageRecommendations.map((y) =>
                  this.renderYardageRecommendationRow(
                    y.id,
                    y.name,
                    y.yardage,
                    y.overriden,
                    y.isChecked,
                    y.isCheckedOverride
                  )
                )}
              </GridTableBody>
            </GridTable>
          </GridTableWrapper>
          {this.state.isOverridesValidate && (
            <ValidateBox>Overriding yardages must be greater than zero</ValidateBox>
          )}
        </ModalContent>
        <ModalActions>
          <CancelButton
            className="cancel_btn"
            uiColor="secondary"
            uiDisabled={this.state.updating}
            onClick={this.handleClose}
          >
            Cancel
          </CancelButton>
          <Button
            type="submit"
            form="cardform"
            uiColor="primary"
            uiDisabled={this.state.updating}
            onClick={this.save}
          >
            Confirm
          </Button>
        </ModalActions>
      </>
    );
  };

  total = (): number | undefined => {
    const totalNum = this.state.widthConfiguration.reduce((all, v) => {
      if (v === undefined) {
        v = 0;
        return all! + v!;
      } else {
        return all! + v!;
      }
    });
    return totalNum;
  };

  private handleNext = async () => {
    const isValidate = this.handleValidateRecommendations();
    if (isValidate) {
      return;
    } else {
      const { widthConfiguration } = this.state;
      this.setState({ updating: true });
      await saveWorkOrderOverrides(
        this.props.draperyOrderId,
        this.props.accountId,
        {
          panelJson: {
            pannel1Width: widthConfiguration[0],
            pannel2Width: widthConfiguration[1],
            pannel3Width: widthConfiguration[2],
            pannel4Width: widthConfiguration[3],
            pannel5Width: widthConfiguration[4],
          },
          yardages: undefined,
        },
        undefined
      );

      let payload: any = {
        draperyOrderId: this.props.draperyOrderId,
        type: 'yardage',
        totalWidth: 0,
        yardages: [],
        quantity:
          this.props &&
          this.props.data &&
          this.props.data.draperyOrder &&
          this.props.data.draperyOrder.quantity,
        newDraperyDesign: this.props.workOrderEditMode ? this.props.draperyOrderDesign : null,
        newDraperyOrderFabrics: this.props.workOrderEditMode
          ? this.props.newDraperyOrderFabrics
          : null,
      };

      if (this.state && this.state.widthConfiguration && this.state.widthConfiguration.length > 0) {
        payload = {
          ...payload,
          newDraperyDesign: {
            ...payload.newDraperyDesign,
            panelJson: this.state.widthConfiguration,
          },
        };
      }
      const res = await getWorkOrderRecommendations(payload);

      const arrOtherFabricYardageRecommendations: any = [];
      // if (!res.error && res.payload.yardages) {
      const data = { ...this.props.data };
      const arrFabrics = [
        ...data.bandings,
        ...data.cordings,
        ...data.flanges,
        ...data.trims,
        ...data.liningsList,
        ...data.othersEmbellishments,
      ].filter((item) => item.draperyOrderFabric || item.draperyOrderLiningsFabric);
      arrFabrics.push(this.props.data.mainFabric);
      this.setState({
        isNext: true,
        yardageRecommendations: res.yardages
          .filter((item: any) => {
            if (item.type === 9) {
              arrOtherFabricYardageRecommendations.push(item);
              return false;
            }
            return item.type !== 9;
          })
          .map((item: any) => {
            const fabric = arrFabrics.find((fabric: any) => {
              if (fabric.name === 'MAIN FABRIC') {
                return fabric.id === item.id;
              }
              if (fabric.draperyOrderFabric) {
                return fabric.draperyOrderFabric.id === item.id;
              }
              if (fabric.draperyOrderLiningsFabric) {
                return fabric.draperyOrderLiningsFabric.id === item.id;
              }
              return false;
            });

            return item.yardage === -1
              ? {
                  ...item,
                  isChecked: true,
                  overriden:
                    fabric.name === 'MAIN FABRIC'
                      ? this.props.data.isCopy &&
                        !(this.props.data.workOrder && this.props.data.workOrder.id)
                        ? ''
                        : fabric.yardsNeeded
                      : fabric.draperyOrderFabric
                        ? fabric.draperyOrderFabric.yardsNeeded
                        : fabric.draperyOrderLiningsFabric
                          ? fabric.draperyOrderLiningsFabric.yardsNeeded
                          : '',
                  isCheckedOverride: false,
                }
              : {
                  ...item,
                  isChecked: true,
                  isCheckedOverride: false,
                  overriden:
                    fabric.name === 'MAIN FABRIC'
                      ? this.props.data.isCopy &&
                        !(this.props.data.workOrder && this.props.data.workOrder.id)
                        ? ''
                        : fabric.yardsNeeded
                      : fabric.draperyOrderFabric
                        ? fabric.draperyOrderFabric.yardsNeeded
                        : fabric.draperyOrderLiningsFabric
                          ? fabric.draperyOrderLiningsFabric.yardsNeeded
                          : '',
                };
          }),
      });
      // }
      this.setState({
        updating: false,
        otherFabricYardageRecommendations: arrOtherFabricYardageRecommendations,
      });
    }
  };

  private handleValidateRecommendations = (): boolean => {
    if (this.state.widthConfiguration.includes(undefined)) {
      this.setState({
        isValidate: true,
        validateMessage: 'Please select the number widths per panel.',
      });
      return true;
    }

    const widths = [...new Set(this.state.widthConfiguration)];
    if (widths && widths.length > 2 && this.props.data.mainFabric.directionOfUse === 2) {
      this.setState({
        isValidate: true,
        validateMessage:
          'A maximum of 2 differing panel widths are allowed when the Main Fabric is railroaded.',
      });
      return true;
    } else {
      this.setState({ isValidate: false, validateMessage: '' });
      return false;
    }
  };

  private renderYardageRecommendationRow = (
    id: number,
    name: string,
    recommended: number,
    overriden?: string,
    isChecked?: boolean,
    isCheckedOverride?: boolean
  ) => {
    const showTooltip =
      name.startsWith('BANDING FABRIC') ||
      name.startsWith('FLANGE FABRIC') ||
      name.startsWith('TRIM FABRIC');
    const showWarning = name.startsWith('WELT CORDING FABRIC') && (!overriden || +overriden < 54);

    return (
      <Row key={name}>
        <BasicGridTableCell>
          {name}
          {showTooltip && (
            <TooltipPopup
              text={
                <TooltipText>
                  Yardage calculations for embellishments made from fabric are calculated to be cut
                  the same direction they will be applied. For example, banding to be applied
                  horizontally, will be calculated as a cut across the width of fabric.
                </TooltipText>
              }
            />
          )}
        </BasicGridTableCell>

        <BasicSubGridTableCell style={{ display: 'flex', justifyContent: 'center' }}>
          {recommended === -1 ? (
            'CALC MANUALLY'
          ) : (
            <div style={{ justifyContent: 'center', marginLeft: '15px' }}>
              <div
                style={{
                  width: '60px',
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  gap: 4,
                }}
              >
                <div style={{ width: '1.5em', display: 'flex', justifyContent: 'center' }}>
                  <CalculatorRadioWrapper
                    style={{ marginRight: '5px', opacity: isChecked ? 1 : 0.5 }}
                  >
                    <CalculatorRadio
                      type="radio"
                      id={`enable-recommended-${id}`}
                      name={id ? `recommended-${id.toString()}` : name}
                      value={1}
                      checked={isChecked}
                      onChange={this.handleYardageOverrideCheckbox}
                    />
                  </CalculatorRadioWrapper>
                </div>

                <span
                  style={{
                    width: 'fit-content',
                    textAlign: 'left',
                    fontVariantNumeric: 'tabular-nums',
                    fontFeatureSettings: "'tnum' 1",
                    lineHeight: 1,
                    opacity: isChecked ? 1 : 0.5,
                  }}
                >
                  {recommended}
                </span>
              </div>
            </div>
          )}
          {showWarning && (
            <TooltipPopup
              errorIcon
              text={
                <TooltipText>
                  QUIPA calculations account for welt cut on the bias from a 54" wide fabric or
                  larger. If your fabric is less than 54", then manual calculation is needed.
                </TooltipText>
              }
            />
          )}
          {/*<span style={{ width: '29px' }}></span>*/}
        </BasicSubGridTableCell>
        {/*</div>*/}
        <BasicSubGridTableCell>
          {/*<Checkbox*/}
          {/*    id={`enable-${id}`}*/}
          {/*    name={id ? id.toString() : name}*/}
          {/*    checked={!!isChecked}*/}
          {/*    onChange={this.handleYardageOverrideCheckbox}*/}
          {/*/>*/}
          <CalculatorRadioWrapper
            style={{ marginRight: '5px', opacity: isCheckedOverride ? 1 : 0.5 }}
          >
            <CalculatorRadio
              type="radio"
              id={`enable-override-${id}`}
              name={id ? `override-${id.toString()}` : name}
              checked={isCheckedOverride}
              onChange={this.handleYardageOverrideCheckbox}
            />
          </CalculatorRadioWrapper>

          <ModalInput
            style={{ opacity: isCheckedOverride ? 1 : 0.5 }}
            id={id.toString()}
            type="number"
            autoComplete="off"
            name={id ? id.toString() : name}
            onChange={this.handleYardageOverrideInput}
            value={overriden}
          />
        </BasicSubGridTableCell>
      </Row>
    );
  };

  private handleValidateOverrides = (): boolean => {
    const targetItem = this.state.yardageRecommendations.find(
      (item) => !!item.isCheckedOverride && (!item.overriden || +item.overriden <= 0)
    );
    if (targetItem !== undefined) {
      this.setState({ isOverridesValidate: true });
      return true;
    } else {
      this.setState({ isOverridesValidate: false });
      return false;
    }
  };

  private save = async () => {
    const panelJson = {
      pannel1Width: this.state.widthConfiguration[0],
      pannel2Width: this.state.widthConfiguration[1],
      pannel3Width: this.state.widthConfiguration[2],
      pannel4Width: this.state.widthConfiguration[3],
      pannel5Width: this.state.widthConfiguration[4],
    };
    const {
      yardageRecommendations,
      otherFabricYardageRecommendations,
      copyYardageRecommendations,
    } = this.state;
    if (this.handleValidateOverrides()) {
      return;
    } else {
      const { accountId, draperyOrderId, isFunctional } = this.props;
      if (!draperyOrderId) {
        return;
      }
      this.setState({ updating: true });

      if (this.props.workOrderEditMode && !this.state.updatingWorkOrder) {
        if (!(await this.props.handleSaveAll('no_message'))) {
          return;
        }

        const newArrayPayloadYardages =
          yardageRecommendations &&
          otherFabricYardageRecommendations &&
          [...yardageRecommendations, ...otherFabricYardageRecommendations].length > 0 &&
          [...yardageRecommendations, ...otherFabricYardageRecommendations].map((item) => {
            return {
              ...item,
              yardage: item.isCheckedOverride ? parseFloat(item.overriden!) : item.yardage,
            };
          });

        this.setState({
          copyYardageRecommendations: newArrayPayloadYardages || [],
          updatingWorkOrder: true,
        });

        await this.loadRecommendations();

        return;
      }
      copyYardageRecommendations.forEach((i) => {
        const foundMatch = [...yardageRecommendations, ...otherFabricYardageRecommendations].find(
          (ii) => ii.name === i.name
        );
        if (foundMatch) {
          i.id = foundMatch.id;
        }
      });

      let payloadForYardage = [];
      if (this.props.workOrderEditMode) {
        payloadForYardage = copyYardageRecommendations;
      } else {
        payloadForYardage = [...yardageRecommendations, ...otherFabricYardageRecommendations];
      }

      const res = await saveWorkOrderOverrides(draperyOrderId, accountId, {
        yardages: payloadForYardage.flatMap((y) => {
          if (y.id === 0) return [];
          return [
            {
              id: y.id,
              name: y.name,
              yardage: y.isCheckedOverride ? parseFloat(y.overriden!) : y.yardage,
            },
          ];
        }),
        panelJson: undefined,
      });

      this.setState({ updating: false, updatingWorkOrder: false });
      if (!res.error) {
        this.props.resetAfterUpdatingEmbellishments();
        await this.props.handleConfirm(
          panelJson,
          this.state.workroomSettings,
          this.state.widthConfiguration
        );

        this.setState({ isNext: !isFunctional });
        // await this.props.saveDraperyOrderPricing();
      } else {
        // todo: handle error
      }
    }
  };

  private loadRecommendations = async () => {
    if (!this.state.isNext) {
      const payload = {
        draperyOrderId: this.props.draperyOrderId,
        type: 'panel',
        totalWidth: 0,
        yardages: [],
        quantity:
          this.props &&
          this.props.data &&
          this.props.data.draperyOrder &&
          this.props.data.draperyOrder.quantity,
        newDraperyDesign: this.props.workOrderEditMode ? this.props.draperyOrderDesign : null,
        newDraperyOrderFabrics: this.props.workOrderEditMode
          ? this.props.newDraperyOrderFabrics
          : null,
      };

      const res = await getWorkOrderRecommendations(payload);

      // if (!res.error && res.payload.totalWidth) {
      this.handlePrefillWidths();
      this.setState({
        totalWidthRecommendation: res.totalWidth,
        // widthConfiguration: this.calculateInitialPanelWidths(res.totalWidth),
      });
      // }
    } else {
      const payload = {
        draperyOrderId: this.props.draperyOrderId,
        type: 'yardage',
        totalWidth: 0,
        quantity:
          this.props &&
          this.props.data &&
          this.props.data.draperyOrder &&
          this.props.data.draperyOrder.quantity,
        yardages: [],
        newDraperyDesign: this.props.workOrderEditMode ? this.props.draperyOrderDesign : null,
        newDraperyOrderFabrics: this.props.workOrderEditMode
          ? this.props.newDraperyOrderFabrics
          : null,
      };

      const res = await getWorkOrderRecommendations({
        ...payload,
        editMode: this.props.editMode,
      });

      // if (!res.error && res.payload.yardages) {
      const arrOtherFabricYardageRecommendations: any = [];

      const data = { ...this.props.data };

      const arrFabrics = [
        ...data.bandings,
        ...data.cordings,
        ...data.flanges,
        ...data.trims,
        ...data.liningsList,
        ...data.othersEmbellishments,
      ].filter((item) => item.draperyOrderFabric || item.draperyOrderLiningsFabric);
      arrFabrics.push(this.props.data.mainFabric);

      const yardageRecommendations = res.yardages
        .filter((item: any) => {
          if (item.type === 9) {
            arrOtherFabricYardageRecommendations.push(item);
            return false;
          }
          return item.type !== 9;
        })
        .map((item: any) => {
          const fabric = arrFabrics.find((fabric: any) => {
            if (fabric.name === 'MAIN FABRIC') {
              return fabric.id === item.id;
            }
            if (fabric.draperyOrderFabric) {
              return fabric.draperyOrderFabric.id === item.id;
            }
            if (fabric.draperyOrderLiningsFabric) {
              return fabric.draperyOrderLiningsFabric.id === item.id;
            }
            return false;
          });
          return item.yardage === -1
            ? {
                ...item,
                isChecked: true,
                overriden:
                  fabric.name === 'MAIN FABRIC'
                    ? this.props.data.isCopy &&
                      !(this.props.data.workOrder && this.props.data.workOrder.id)
                      ? ''
                      : fabric.yardsNeeded
                    : fabric.draperyOrderFabric
                      ? fabric.draperyOrderFabric.yardsNeeded
                      : fabric.draperyOrderLiningsFabric
                        ? fabric.draperyOrderLiningsFabric.yardsNeeded
                        : '',
                isCheckedOverride: false,
              }
            : {
                ...item,
                isChecked: true,
                isCheckedOverride: false,
                overriden:
                  fabric.name === 'MAIN FABRIC'
                    ? this.props.data.isCopy &&
                      !(this.props.data.workOrder && this.props.data.workOrder.id)
                      ? ''
                      : fabric.yardsNeeded
                    : fabric.draperyOrderFabric
                      ? fabric.draperyOrderFabric.yardsNeeded
                      : fabric.draperyOrderLiningsFabric
                        ? fabric.draperyOrderLiningsFabric.yardsNeeded
                        : '',
              };
        });

      this.setState((prev) => {
        return {
          ...prev,
          yardageRecommendations,
          otherFabricYardageRecommendations: arrOtherFabricYardageRecommendations,
        };
      });
      // }
    }
  };

  private handleYardageOverrideCheckbox = (e: ChangeEvent<HTMLInputElement>) => {
    const val = e.currentTarget.checked;
    const name = e.currentTarget.name;
    const confIdx = this.state.yardageRecommendations.findIndex((y) => {
      if (!y.id) {
        return y.name === name;
      } else {
        return y.id === parseInt(name.split('-')[1], 10);
      }
    });
    const conf = this.state.yardageRecommendations[confIdx];
    if (!conf) {
      return;
    }
    if (conf.yardage === -1) {
      return;
    }
    const confUpdate = { ...conf, isChecked: val };
    if (val && !('overriden' in confUpdate)) {
      confUpdate.overriden = confUpdate.yardage ? confUpdate.yardage.toString() : '';
    } else {
      // confUpdate.overriden = "";
    }
    const updateObj = {};
    if (name.includes('override')) {
      updateObj['isChecked'] = false;
      updateObj['isCheckedOverride'] = true;
    } else if (name.includes('recommended')) {
      updateObj['isChecked'] = true;
      updateObj['isCheckedOverride'] = false;
    }

    this.setState({
      yardageRecommendations: [
        ...this.state.yardageRecommendations.slice(0, confIdx),
        { ...confUpdate, ...updateObj },
        ...this.state.yardageRecommendations.slice(confIdx + 1),
      ],
      copyYardageRecommendations: [
        ...this.state.yardageRecommendations.slice(0, confIdx),
        { ...confUpdate, ...updateObj },
        ...this.state.yardageRecommendations.slice(confIdx + 1),
      ],
    });
  };

  private handleYardageOverrideInput = (e: ChangeEvent<HTMLInputElement>) => {
    let val = e.currentTarget.value;
    const id = e.currentTarget.id;
    const name = e.currentTarget.name;
    if (!/^\d*(\.\d{0,2})?$/.test(val)) {
      val = val.slice(0, -1);
    }
    let value = parseFloat(val);

    if (value > 9999.99) {
      val = '9999.99';
    }
    const confIdx = this.state.yardageRecommendations.findIndex((y) => {
      if (!y.id) {
        return y.name === name;
      } else {
        return y.id === parseInt(id, 10);
      }
    });

    const conf = this.state.yardageRecommendations[confIdx];
    if (!conf) {
      return;
    }
    if (this.state.yardageRecommendations.length > 1) {
      this.setState({
        yardageRecommendations: [
          ...this.state.yardageRecommendations.slice(0, confIdx),
          { ...conf, overriden: val, isCheckedOverride: true, isChecked: false },
          ...this.state.yardageRecommendations.slice(confIdx + 1),
        ],
        copyYardageRecommendations: [
          ...this.state.yardageRecommendations.slice(0, confIdx),
          { ...conf, overriden: val, isCheckedOverride: true, isChecked: false },
          ...this.state.yardageRecommendations.slice(confIdx + 1),
        ],
      });
    } else {
      this.setState({
        yardageRecommendations: [
          { ...conf, overriden: val, isCheckedOverride: true, isChecked: false },
        ],
        copyYardageRecommendations: [
          { ...conf, overriden: val, isCheckedOverride: true, isChecked: false },
        ],
      });
    }
  };

  private handleClose = () => {
    if (this.state.updating) {
      return;
    }
    this.handleNumberOfPanels(this.props.data.draperyOrderDesign.panelType);
    this.setState({
      isNext: !this.props.isFunctional,
      totalWidthRecommendation: 0,
      widthConfiguration: [],
      yardageRecommendations: [],
      isValidate: false,
      isOverridesValidate: false,
    });
    this.props.resetDraperyOrderNewFabrics();
    this.props.onRequestClose();
  };

  private handlePanelConfigurationImage = () => {
    switch (this.props.panelType) {
      case 'center': {
        return <DraperyConfigurationSingleCenterPanel />;
      }
      case 'left': {
        return <DraperyConfigurationSingleLeftPanel />;
      }
      case 'right': {
        return <DraperyConfigurationSingleRightPanel />;
      }
      case 'pair': {
        return <DraperyConfigurationPair />;
      }
      case 'three-panels': {
        return <DraperyConfiguration3Panels />;
      }
      case 'four-panels': {
        return <DraperyConfiguration4Panels />;
      }
      case 'five-panels': {
        return <DraperyConfiguration5Panels />;
      }
    }
  };

  private calculateInitialPanelWidths(totalWidth?: number): Array<number | undefined> {
    let configurationValueQuantity = 0;
    const valueQuantityArray: Array<number | undefined> = [];
    switch (this.props.panelType) {
      case 'center': {
        configurationValueQuantity = 1;
        break;
      }
      case 'left': {
        configurationValueQuantity = 1;
        break;
      }
      case 'right': {
        configurationValueQuantity = 1;
        break;
      }
      case 'pair': {
        configurationValueQuantity = 2;
        break;
      }
      case 'three-panels': {
        configurationValueQuantity = 3;
        break;
      }
      case 'four-panels': {
        configurationValueQuantity = 4;
        break;
      }
      case 'five-panels': {
        configurationValueQuantity = 5;
        break;
      }
    }
    for (let i = 0; i < configurationValueQuantity; i++) {
      valueQuantityArray.push(undefined);
    }
    return valueQuantityArray;
  }

  private generateConfigurationValue = () => {
    let inputCount = 10; //random number, no significance

    return this.state.widthConfiguration.map((item, idx) => {
      inputCount++;
      return (
        <PanelConfigurationValueWrapper
          key={`recom-input-${inputCount}`} //workaround for sonar lint when using idx as key
          panelType={this.props.panelType}
        >
          <PanelConfigurationValue
            selectList={[
              '0',
              '0.5',
              '1',
              '1.5',
              '2',
              '2.5',
              '3',
              '3.5',
              '4',
              '4.5',
              '5',
              '5.5',
              '6',
              '6.5',
              '7',
              '7.5',
              '8',
            ]}
            handleClickSelect={(value) =>
              this.handleConfigurationWidthChange(value, idx.toString())
            }
            valueSelect={item === undefined ? '' : item.toString()}
            flexDirection="column"
            name={idx.toString()}
            noClearBox
            noArrow
            editable
            type="number"
            uiBorderStyle={`solid 2px ${this.state.widthsBordercolor[idx]}`}
          />
          Width(s)
        </PanelConfigurationValueWrapper>
      );
    });
  };

  private handleConfigurationWidthChange = (value: string | number, name: string) => {
    const idx = parseInt(name, 10);
    let newWidth: number | undefined = undefined;

    const invalidCharactersRegex = /[e\-\+]/;
    const validValueRegex = /^(0|[1-9]\d{0,1})(\.\d{0,2})?$/;

    const stringValue = typeof value === 'number' ? value.toString() : value;

    if (!invalidCharactersRegex.test(stringValue) && validValueRegex.test(stringValue)) {
      let processedValue = stringValue.replace(/[^\d.]/g, '');
      processedValue = processedValue.replace(/\.{2,}/g, '.');

      const firstDotIndex = processedValue.indexOf('.');
      if (firstDotIndex !== -1) {
        processedValue = `${processedValue.slice(0, firstDotIndex + 1)}${processedValue
          .slice(firstDotIndex + 1)
          .replace(/\./g, '')}`;
      }

      const decimalParts = processedValue.split('.');
      if (decimalParts.length > 1) {
        processedValue = `${decimalParts[0]}.${decimalParts[1].slice(0, 2)}`;
      }

      newWidth = parseFloat(processedValue);
      if (!isNaN(newWidth)) {
        newWidth = Math.min(Math.max(newWidth, 0), 99.99);
        newWidth = parseFloat(newWidth.toFixed(2));
      }
    }
    const widthsBordercolorArr = [...this.state.widthsBordercolor];

    if (newWidth || newWidth === 0) {
      widthsBordercolorArr[idx] = PANEL_WIDTH_BORDER_COLOR;
    } else {
      widthsBordercolorArr[idx] = PANEL_WIDTH_MISSING_BORDER_COLOR;
    }
    this.setState({ widthsBordercolor: widthsBordercolorArr });
    this.setState({
      widthConfiguration: [
        ...this.state.widthConfiguration.slice(0, idx),
        newWidth,
        ...this.state.widthConfiguration.slice(idx + 1),
      ],
    });
  };

  // private roundWidth(width: number): number {
  //     const wholeNum = Math.floor(width);
  //     return wholeNum === width ? width : width <= wholeNum + 0.5 ? wholeNum + 0.5 : Math.ceil(width);
  // }
}

function mapStateToProps(
  state: RootState,
  ownProps: RecommendationsOverridesModalOwnProps
): RecommendationsOverridesModalProps {
  return {
    ...ownProps,
    accountId: parseFloat(localStorage.getItem('accountId') || '0'),
    editMode: ownProps.editMode,
  };
}

export const RecommendationsOverridesModal = connect(mapStateToProps)(
  RecommendationsOverridesModalComponent
);
